import React,{useState, useEffect} from "react";
import { useProposalContext } from "../../components/HalfPage_Popup/ProposalHalfUnsolicated";
import DocumentListItem from '../../components/HalfPage_Popup/DocumentListItem';
import CryptoUtils from "../../util/cryptoUtils";
import ProposalTitle from "../../components/ProposalTitle/ProposalTitle";
import '../HalfPage_Popup/HalfPageBreif.css';
import { useLocation, useNavigate } from "react-router-dom";
import { useLanguage } from '../../context/Languagecontext';
import FallBackLabel from '../../global/Globals_Eng.json';
import { formatCurrency } from "../../util/util";

export default function ProposalDetails({expanded,currentStatus,title,onTitlechange,producerNavProps}) {
    const { proposalData,
        setIsExpanded,
        isExpanded,
        isSynopsisExpanded,
        toggleSynopsis,
        isLogLineExpanded,
        toggleLogLine,
        isepisodeStructureExpanded,
        toggleEpisode,
        islocationStudioInfoExpanded,
        toggleLocation,
        iscastPresenterInfoExpanded,
        toggleCast,
        isbrandIntegrationExpanded,
        toggleBrand,
        isprojectStatusExpanded,
        toggleProjectStatus,
        iskeyTeamsExpanded,
        toggleKeyteam,
        fileItems,
        roleId
    } = useProposalContext();
    const { Globals ,languages, setLanguages } = useLanguage();
    const [roleID, setRoleID]=useState(CryptoUtils.getFromLocalStorage("roleId").toString());
    const navigate = useNavigate();
    const location = useLocation();
    const producerID = proposalData[0]?.producerId;
    CryptoUtils.saveToLocalStorage('pKey', producerID);
    const handleTitleChange = (newTitle)=>{
        onTitlechange(newTitle)
      }
    const handleProducer=()=>{
        localStorage.setItem('isProducerViewed',true);
        if (proposalData[0]?.producerType === "Individual") {
            navigate(Globals.NAVPATH.SYS_ADMIN_PRODUCER_APPROVE_REJECT, { state: { producerNavProps } })
        }
        else {
            navigate(Globals.NAVPATH.SYS_ADMIN_COMP_APPROVE_REJECT, { state: { producerNavProps } })
        } 
    }

    const proposalDetail=()=>{
        return(
            <>
            { <p className="text-content-company">
                    {(roleID !== Globals.USER_ROLES.PRODUCER) ? (<span className="halfscreen-producer-name" onClick={handleProducer}>{proposalData[0]?.producerName || CryptoUtils.getFromLocalStorage('companyName')}</span>) : (proposalData[0]?.producerName || CryptoUtils.getFromLocalStorage('companyName'))}
                 <span className="text"> {Globals.HALFSCREEN.PRESENTS}</span>
             </p>}
             <div className="proposal-title">
          <ProposalTitle title={title} proposalId={proposalData[0]?.proposalId || proposalData?.[0]?.proposalId || ""}  proposalDetailId={proposalData[0]?.proposalDetailId || proposalData?.[0]?.proposalDetailId || ""} status={currentStatus} onSave={handleTitleChange}/>
        </div>
             <div className="proposal-container">
                 <div className="proposal-half-page-left">

                     <div className="unsolicated-proposal-text">
                         <div className="unsolicated-heading">
                             {Globals.UNSOLICITED_PROPOSAL_HALF.COUNTRY}{" "}
                         </div>
                         <div className="text-content-unsolicated">
                             {proposalData[0]?.countryName}
                         </div>
                     </div>

                     <div className="unsolicated-proposal-text">
                         <div className="unsolicated-heading">
                             {Globals.UNSOLICITED_PROPOSAL_HALF.SCRIPTED.split("/").map(
                                 (part, index) => (
                                     <>
                                         {index === 0 ?part.trim()+' /':part.trim()}
                                         {index === 0 && <br />}
                                     </>
                                 )
                             )}{" "}
                         </div>
                         <div className="text-content-unsolicated">
                             {proposalData[0]?.contentName}
                         </div>
                     </div>

                     <div className="unsolicated-proposal-text">
                         <div className="unsolicated-heading">
                             {Globals.UNSOLICITED_PROPOSAL_HALF.CLUSTER}{" "}
                         </div>
                         <div className="text-content-unsolicated">
                             {proposalData[0]?.clusterName}
                         </div>
                     </div>
                     <div className="unsolicated-proposal-text">
                         <div className="unsolicated-heading">
                             {Globals.UNSOLICITED_PROPOSAL_HALF.GENRE}{" "}
                         </div>
                         <div className="text-content-unsolicated">
                             {proposalData[0]?.genreName}
                         </div>
                     </div>
                     <div className="unsolicated-proposal-text">
                         <div className="unsolicated-heading">
                             {Globals.UNSOLICITED_PROPOSAL_HALF.CHANNEL}{" "}
                         </div>
                         <div className="text-content-unsolicated">
                             {proposalData[0]?.channelName}
                         </div>
                     </div>
                     {proposalData[0]?.othergenre && (
                         <div className="unsolicated-proposal-text">
                             <div className="unsolicated-heading">
                                 {Globals.UNSOLICITED_PROPOSAL_HALF.OTHERGENRE}{" "}
                             </div>
                             <div className="text-content-unsolicated">
                                 {proposalData[0]?.othergenre}
                             </div>
                         </div>
                     )}

                     <div className="unsolicated-proposal-text">
                         <div className="unsolicated-heading">
                             {Globals.UNSOLICITED_PROPOSAL_HALF.LANGUAGE}{" "}
                         </div>
                         <div className="text-content-unsolicated">
                             {proposalData[0]?.languageName}
                         </div>
                     </div>

                     <div className="unsolicated-proposal-text">
                         <div className="unsolicated-heading">
                             {Globals.UNSOLICITED_PROPOSAL_HALF.PRODUCTIONTYPE}{" "}
                         </div>
                         <div className="text-content-unsolicated">
                             {proposalData[0]?.productionTypeName}
                         </div>
                     </div>

                     <div className="unsolicated-proposal-text">
                         <div className="unsolicated-heading">
                             {Globals.UNSOLICITED_PROPOSAL_HALF.TARGET_AUDIENCE}{" "}
                         </div>
                         <div className="text-content-unsolicated">
                             {proposalData[0]?.targetAudienceName}
                         </div>
                     </div>

                     <div className="unsolicated-proposal-text">
                         <div className="unsolicated-heading">
                             {Globals.UNSOLICITED_PROPOSAL_HALF.FORMAT}{" "}
                         </div>
                         <div className="text-content-unsolicated">
                             {proposalData[0]?.formatName}
                         </div>
                     </div>

                     {(proposalData[0]?.formatName === Globals.UNSOLICITED_PROPOSAL.BIG_SERIES ||
                         proposalData[0]?.formatName === Globals.UNSOLICITED_PROPOSAL.MINI_SERIES ||
                        proposalData[0]?.formatName===Globals.UNSOLICITED_PROPOSAL.BIG_SERIES_MORE) ? (
                         <>
                             <div className="unsolicated-proposal-text">
                                 <div className="unsolicated-heading">
                                     {Globals.UNSOLICITED_PROPOSAL_HALF.NOOFEPISODES}{" "}
                                 </div>
                                 <div className="text-content-unsolicated">
                                     {proposalData[0]?.noOfEpisodes}
                                 </div>
                             </div>
                             <div className="unsolicated-proposal-text">
                                 <div className="unsolicated-heading">
                                     {Globals.UNSOLICITED_PROPOSAL_HALF.EPDURATION}{" "}
                                 </div>
                                 <div className="text-content-unsolicated">
                                     {proposalData[0]?.episodeDuration}
                                 </div>
                             </div>
                             <div className="unsolicated-proposal-text">
                                 <div className="unsolicated-heading">
                                     {Globals.UNSOLICITED_PROPOSAL_HALF.TOTALEPDURATION}{" "}
                                 </div>
                                 <div className="text-content-unsolicated">
                                     {proposalData[0]?.totalEpisodesDuration}
                                 </div>
                             </div>
                         </>
                     ) : (
                         <div className="unsolicated-proposal-text">
                             <div className="unsolicated-heading">
                                 {Globals.UNSOLICITED_PROPOSAL_HALF.DURATIONINMINS}{" "}
                             </div>
                             <div className="text-content-unsolicated">
                                 {proposalData[0]?.episodeDuration}
                             </div>
                         </div>
                     )}

                     <div className="proposal-heading">
                         {Globals.UNSOLICITED_PROPOSAL_HALF.SYNOPSIS}
                     </div>
                     <p className="text-content">
                         {proposalData[0]?.synopsis ? (
                             <>
                                 {proposalData[0]?.synopsis.length > 294 ? (
                                     <>
                                         {isSynopsisExpanded
                                             ? proposalData[0]?.synopsis
                                             : `${proposalData[0]?.synopsis.substring(0, 294)}...`}
                                         <div className='view'>
                                             <span className="view-more" onClick={toggleSynopsis}>
                                                 {isSynopsisExpanded ? "View Less" : "View More"}
                                             </span></div>
                                     </>
                                 ) : (
                                     proposalData[0]?.synopsis
                                 )}
                             </>
                         ) : (
                             Globals.HALFSCREEN.NA
                         )}
                     </p>
                     <div className="proposal-heading">
                         {Globals.SOLICITED_PROPOSAL.LOGLINE}
                     </div>
                     <p className="text-content">
                         {proposalData[0]?.logLine ? (
                             <>
                                 {proposalData[0]?.logLine.length > 294 ? (
                                     <>
                                         {isLogLineExpanded
                                             ? proposalData[0]?.logLine
                                             : `${proposalData[0]?.logLine.substring(0, 294)}...`}
                                         <div className='view'>
                                             <span className="view-more" onClick={toggleLogLine}>
                                                 {isLogLineExpanded ? "View Less" : "View More"}
                                             </span></div>
                                     </>
                                 ) : (
                                     proposalData[0]?.logLine
                                 )}
                             </>
                         ) : (
                             Globals.HALFSCREEN.NA
                         )}
                     </p>

                     <div className="unsolicated-proposal-text">
                         <div className="unsolicated-heading">
                             {Globals.UNSOLICITED_PROPOSAL_HALF.TARGET_BUDGET}{" "}
                         </div>
                         <div className="text-content-unsolicated">
                         {proposalData[0]?.currency} {formatCurrency(proposalData[0]?.targetBudget)} 
                         </div>
                     </div>

                     {(proposalData[0]?.formatType==='E'||proposalData[0]?.formatType==='M')&&<><div className="unsolicated-heading">
                         {Globals.UNSOLICITED_PROPOSAL_HALF.EPISODE_STRUCTURE}
                     </div>
                     <p className="text-content">
                         {proposalData[0]?.episodeStructure ? (
                             <>
                                 {proposalData[0]?.episodeStructure.length > 294 ? (
                                     <>
                                         {isepisodeStructureExpanded
                                             ? proposalData[0]?.episodeStructure
                                             : `${proposalData[0]?.episodeStructure.substring(0, 294)}...`}
                                         <div className='view'>
                                             <span className="view-more" onClick={toggleEpisode}>
                                                 {isepisodeStructureExpanded ? "View Less" : "View More"}
                                             </span></div>
                                     </>
                                 ) : (
                                     proposalData[0]?.episodeStructure
                                 )}
                             </>
                         ) : (
                             Globals.HALFSCREEN.NA
                         )}
                     </p></>}


                     <div className="unsolicated-heading">
                         {Globals.UNSOLICITED_PROPOSAL_HALF.LOCATION}
                     </div>
                     <p className="text-content">
                         {proposalData[0]?.locationStudioInfo ? (
                             <>
                                 {proposalData[0]?.locationStudioInfo.length > 294 ? (
                                     <>
                                         {islocationStudioInfoExpanded
                                             ? proposalData[0]?.locationStudioInfo
                                             : `${proposalData[0]?.locationStudioInfo.substring(0, 294)}...`}
                                         <div className='view'>
                                             <span className="view-more" onClick={toggleLocation}>
                                                 {islocationStudioInfoExpanded ? "View Less" : "View More"}
                                             </span></div>
                                     </>
                                 ) : (
                                     proposalData[0]?.locationStudioInfo
                                 )}
                             </>
                         ) : (
                             Globals.HALFSCREEN.NA
                         )}
                     </p>


                     <div className="unsolicated-heading">
                         {Globals.UNSOLICITED_PROPOSAL_HALF.CAST_PRESENTER_INFO}
                     </div>
                     <p className="text-content">
                         {proposalData[0]?.castPresenterInfo ? (
                             <>
                                 {proposalData[0]?.castPresenterInfo.length > 294 ? (
                                     <>
                                         {iscastPresenterInfoExpanded
                                             ? proposalData[0]?.castPresenterInfo
                                             : `${proposalData[0]?.castPresenterInfo.substring(0, 294)}...`}
                                         <div className='view'>
                                             <span className="view-more" onClick={toggleCast}>
                                                 {iscastPresenterInfoExpanded ? "View Less" : "View More"}
                                             </span></div>
                                     </>
                                 ) : (
                                     proposalData[0]?.castPresenterInfo
                                 )}
                             </>
                         ) : (
                             Globals.HALFSCREEN.NA
                         )}
                     </p>


                     <div className="unsolicated-heading">
                         {Globals.UNSOLICITED_PROPOSAL_HALF.BRAND_INTEGRATION_OPPORTUNITIES}</div>
                     <p className="text-content">
                         {proposalData[0]?.brandIntegration ? (
                             <>
                                 {proposalData[0]?.brandIntegration.length > 294 ? (
                                     <>
                                         {isbrandIntegrationExpanded
                                             ? proposalData[0]?.brandIntegration
                                             : `${proposalData[0]?.brandIntegration.substring(0, 294)}...`}
                                         <div className='view'>
                                             <span className="view-more" onClick={toggleBrand}>
                                                 {isbrandIntegrationExpanded ? "View Less" : "View More"}
                                             </span></div>
                                     </>
                                 ) : (
                                     proposalData[0]?.brandIntegration
                                 )}
                             </>
                         ) : (
                             Globals.HALFSCREEN.NA
                         )}
                     </p>


                     <div className="unsolicated-heading">
                         {Globals.UNSOLICITED_PROPOSAL_HALF.PROJECT_STATUS}
                     </div>
                     <p className="text-content">
                         {proposalData[0]?.synopsis ? (
                             <>
                                 {proposalData[0]?.projectStatus.length > 294 ? (
                                     <>
                                         {isprojectStatusExpanded
                                             ? proposalData[0]?.projectStatus
                                             : `${proposalData[0]?.projectStatus.substring(0, 294)}...`}
                                         <div className='view'>
                                             <span className="view-more" onClick={toggleProjectStatus}>
                                                 {isprojectStatusExpanded ? "View Less" : "View More"}
                                             </span></div>
                                     </>
                                 ) : (
                                     proposalData[0]?.projectStatus?proposalData[0]?.projectStatus:Globals.HALFSCREEN.NA
                                 )}
                             </>
                         ) : (
                             Globals.HALFSCREEN.NA
                         )}
                     </p>


                     <div className="unsolicated-heading">
                         {Globals.UNSOLICITED_PROPOSAL_HALF.KEY_TEAM}</div>
                     <p className="text-content">
                         {proposalData[0]?.keyTeams ? (
                             <>
                                 {proposalData[0]?.keyTeams.length > 294 ? (
                                     <>
                                         {iskeyTeamsExpanded
                                             ? proposalData[0]?.keyTeams
                                             : `${proposalData[0]?.keyTeams.substring(0, 294)}...`}
                                         <div className='view'>
                                             <span className="view-more" onClick={toggleKeyteam}>
                                                 {iskeyTeamsExpanded ? "View Less" : "View More"}
                                             </span></div>
                                     </>
                                 ) : (
                                     proposalData[0]?.keyTeams
                                 )}
                             </>
                         ) : (
                             Globals.HALFSCREEN.NA
                         )}
                     </p>
                     {proposalData[0]?.artistName && (
                         <div className="unsolicated-proposal-text">
                             <div className="unsolicated-heading">
                                 {Globals.UNSOLICITED_PROPOSAL_HALF.ARTIST_NAME}{" "}
                             </div>
                             <div className="text-content-unsolicated">
                                 {proposalData[0]?.artistName}
                             </div>
                         </div>
                     )}

                     {proposalData[0]?.songName && (
                         <div className="unsolicated-proposal-text">
                             <div className="unsolicated-heading">
                                 {Globals.UNSOLICITED_PROPOSAL_HALF.SONG_NAME}{" "}
                             </div>
                             <div className="text-content-unsolicated">
                                 {proposalData[0]?.songName}
                             </div>
                         </div>
                     )}


                     <div className="unsolicated-heading">
                         {Globals.UNSOLICITED_PROPOSAL_HALF.REFERENCE_LINKS}
                     </div>
                     <div className="text-content">
                         {proposalData[0]?.referenceLinks ?
                             proposalData[0].referenceLinks.split(",").map((link, index) => {
                                 const trimmedLink = link.trim();
                                 const linkVariableName = `${Globals.HALF_PAGE_REFERENCE_LINK} ${index + 1}`;

                                 return (
                                     <span key={index} className="">
                                         <a
                                            //  href={trimmedLink}
                                             href={trimmedLink.startsWith('http://') || trimmedLink.startsWith('https://') ? trimmedLink : `http://${trimmedLink}`}
                                             alt={linkVariableName}
                                             target="_blank"
                                             rel="noopener noreferrer"
                                             className="link-value"
                                         >
                                             {linkVariableName}
                                         </a>
                                         {index < proposalData[0].referenceLinks.split(",").length - 1 && (
                                             <span className="separator">, </span>
                                         )}
                                     </span>
                                 );
                             }):Globals.HALFSCREEN.NA}
                     </div>



                 </div>
                 <img id="line-separator" src={Globals.IMG.LINE} alt="" />
                 <div className="proposal-right-content">
                     {fileItems.length > 0 ? (
                         <div>
                              {fileItems.map(({foundDoc, docFor, heading}) => <DocumentListItem foundDoc={foundDoc} docFor={docFor} heading={heading}/>)} 
                         </div>
                     ) : (
                         <p>NA</p>
                     )}
                 </div>
             </div>
         </>
        )
    }
    return (<>
        <div className="proposal-title">
            <div className="proposal-details">
                {expanded?<>
                    <div style={{ display: "flex",alignItems:"flex-end"}}>
                    <div className="proposal-details" style={{ flex: "1" }}> {Globals.UNSOLICITED_PROPOSAL_HALF.DETAILS}</div>
                    <div style={{ marginRight: "20px" }}><img
                        onClick={() => setIsExpanded(!isExpanded)}
                        src={isExpanded ? Globals.IMG.ARROW_UP : Globals.IMG.ARROW_DOWN}
                        alt="toggle icon"
                        style={{
                            top: "3px",
                            position: "relative"
                        }}
                    /></div>
                </div>
                {isExpanded && proposalDetail() }
                    </>:<>
                    <div style={{ display: "flex", flexDirection:"column"}}>
                    <div> {Globals.UNSOLICITED_PROPOSAL_HALF.DETAILS}</div>
                    {proposalDetail()} 
                    </div>
                    </>
                }
               


            </div>
            


        </div>
    </>)
}